const state = {
  bookingDate: '',
  bookingStartAddr: '', //开始地址
  bookingEndAddr: '', //目的地址
  bookingStartPointLo: '', //经
  bookingStartPointLa: '', //纬
  bookingEndPointLo: '', //经
  bookingEndPointLa: '', //纬
  isGo: true, //对调地址
  serviceType: 2,
  businessSign: '',
  MarkName: '',
  CityName: '中山市'
}

// 以计算属性形式返回
const getters = {

}

// 异步获取值后commit mutations更改值
const actions = {

}

// 更改值
const mutations = {
  setWxLoginInfo(state, loginInfo) {
    state.OpenId = loginInfo.openid;
    state.IsLogin = true;
    state.SessionKey = loginInfo.session_key;
  },
  setData(state, dataObj) {
    for (let prop in dataObj) {
      if (dataObj[prop] !== undefined) {
        state[prop] = dataObj[prop];
      }
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/appoint.js